import { FileSelectField, FormFieldV2 as FormField, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { hanThanhToanSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { FormFieldActions, FormFieldState } from '../../hooks/useFormState';

import { type HanThanhToan, KhachHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export default function OtherTab({ formMode, formState: { state, actions } }: OtherTabProps) {
  return (
    <div className='p-4'>
      <div className='flex flex-col justify-between lg:flex-row'>
        {/* Left column */}
        <div className='w-full space-y-1'>
          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Mã thanh toán</Label>
            <SearchField<HanThanhToan>
              columnDisplay='ma_tt'
              displayRelatedField='ten_tt'
              searchEndpoint={`/${QUERY_KEYS.HAN_THANH_TOAN}`}
              searchColumns={hanThanhToanSearchColumns}
              value={state.hanThanhToan?.ma_tt || ''}
              relatedFieldValue={state.hanThanhToan?.ten_tt || ''}
              onRowSelection={actions.setHanThanhToan}
              disabled={formMode === 'view'}
              dialogTitle='Danh mục hạn thanh toán'
            />
          </div>

          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Lý do hủy</Label>
            <div className='flex-1'>
              <FormField
                name='ly_do_huy'
                type='text'
                disabled={formMode === 'view'}
                placeholder='Nhập lý do hủy lá đơn'
              />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Lý do điều chỉnh</Label>
            <div className='flex-1'>
              <FormField
                name='ly_do'
                type='text'
                disabled={formMode === 'view'}
                placeholder='Nhập lý do thay thế hoặc điều chỉnh hóa đơn điện tử'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
